import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface FloatingLayerProps extends BoxProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  cardHeight?: BoxProps["height"];
  transitionTimeMs?: number;
}

export const FloatingLayer = ({
  children,
  isOpen,
  onClose,
  cardHeight = "65vh",
  transitionTimeMs = 300,
  ...props
}: FloatingLayerProps) => {
  return (
    <>
      <Box
        position={"fixed"}
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundColor={"rgba(0,0,0,0.5)"}
        opacity={isOpen ? "1" : "0"}
        zIndex={isOpen ? 98 : -99}
        transition={`all ${transitionTimeMs / 1000}s`}
      />
      <Box
        position={"fixed"}
        bottom={0}
        left={0}
        width={"100%"}
        height={"100%"}
        zIndex={99}
        display={"flex"}
        flexDir={"column"}
        justifyContent={"flex-end"}
        transform={isOpen ? undefined : "translateY(100%)"}
        transition={`all ${transitionTimeMs / 1000}s`}
      >
        <Box onClick={() => onClose()} width={"100%"} height={"100%"} />
        <Box
          width={"100%"}
          backgroundColor={"white"}
          height={cardHeight}
          minHeight={cardHeight}
          borderRadius={"1rem"}
          padding={"1rem"}
          overflowY={"auto"}
          {...props}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};
